// Zerlegt die Rechtstexte (Impressum, Datenschutz) in Blöcke; rein, ohne Importe (Format wie im PersoNYzer).
// Blöcke: titel (# ), abschnitt (## ), fett (Zeile nur aus **…**), liste (- …), absatz (Zeilen bis zur Leerzeile).
// Inline: text, fett (**…**), link intern ([Text](/pfad)) und extern (https://…).

const INLINE = /\*\*(.+?)\*\*|\[([^\]]+)\]\((\/[^)\s]*)\)|(https:\/\/[^\s)]+)/g;
const SATZZEICHEN_ENDE = /[.,;:!?]+$/;

export function zerlegeZeile(zeile) {
  const teile = [];
  let rest = 0;
  const text = (t) => { if (t) teile.push({ typ: 'text', text: t }); };
  for (const t of zeile.matchAll(INLINE)) {
    text(zeile.slice(rest, t.index));
    if (t[1] !== undefined) teile.push({ typ: 'fett', text: t[1] });
    else if (t[2] !== undefined) teile.push({ typ: 'link', text: t[2], ziel: t[3], extern: false });
    else {
      const ende = (t[4].match(SATZZEICHEN_ENDE) || [''])[0];
      const url = ende ? t[4].slice(0, -ende.length) : t[4];
      teile.push({ typ: 'link', text: url, ziel: url, extern: true });
      text(ende);
    }
    rest = t.index + t[0].length;
  }
  text(zeile.slice(rest));
  return teile;
}

export function zerlegeRechtsText(quelle) {
  const bloecke = [];
  let absatz = null;
  let liste = null;
  const schliessen = () => { absatz = null; liste = null; };
  for (const zeile of String(quelle).replace(/\r\n/g, '\n').split('\n')) {
    if (zeile.trim() === '') { schliessen(); continue; }
    if (zeile.startsWith('## ')) { schliessen(); bloecke.push({ typ: 'abschnitt', text: zeile.slice(3).trim() }); continue; }
    if (zeile.startsWith('# ')) { schliessen(); bloecke.push({ typ: 'titel', text: zeile.slice(2).trim() }); continue; }
    if (/^\*\*[^*]+\*\*$/.test(zeile.trim())) {
      schliessen();
      bloecke.push({ typ: 'fett', text: zeile.trim().slice(2, -2) });
      continue;
    }
    if (zeile.startsWith('- ')) {
      absatz = null;
      if (!liste) { liste = { typ: 'liste', punkte: [] }; bloecke.push(liste); }
      liste.punkte.push(zerlegeZeile(zeile.slice(2)));
      continue;
    }
    liste = null;
    if (!absatz) { absatz = { typ: 'absatz', zeilen: [] }; bloecke.push(absatz); }
    absatz.zeilen.push(zerlegeZeile(zeile));
  }
  return bloecke;
}
